import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import { AdminPage, AuthCallback } from "@/pages/Admin";
import { LanguageProvider } from "@/lib/i18n";

function AppRouter() {
  const location = useLocation();
  // Auth callback: session_id arrives in URL fragment after Google OAuth
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </div>
    </LanguageProvider>
  );
}

export default App;
